import React from "react";
import Container from "../../../utility/ui-components/container";
import Section from "../../../utility/ui-components/section";
import SectionHeading from "../../../utility/ui-components/sectionHeading";
import home from "../../../../common/assets/data/home";
import { Link } from "react-router-dom";
import Button from "../../../utility/ui-components/button";
import Anime from "react-anime";
import { AnimationOnScroll } from "react-animation-on-scroll";
import StackImage from "../../../utility/ui-components/images/stackImage";
import DefaultImage from "../../../utility/ui-components/images/default";
import PopImage from "../../../utility/ui-components/images/popImage";
import GroupImage from "../../../utility/ui-components/images/groupImage";
import RotateImage from "../../../utility/ui-components/images/rotateImage";
function AboutSection() {
  const data = home.AboutSection;
  console.log(data.aboutImg, "about-image");
  return (
    <Section className="">
      <Container>
        <div className="">
          <div className="lg:grid lg:grid-cols-2 gap-16 items-center ">
            <div>
              <AnimationOnScroll animateIn="animate__bounceIn">
                <SectionHeading heading={data.Heading} />
              </AnimationOnScroll>
              <p className="text-center md:text-left text-base md:text-lg">
                {data.paragraph}
              </p>

              {data.buttons.map((button, index) => (
                <div
                  key={index + 1}
                  className="text-center md:text-left  my-5 md:ml-0"
                >
                  <Link to={button.path}>
                    <Button type="button" button={button} />
                  </Link>
                </div>
              ))}
            </div>
            <div className="w-[100%] h-[100%]">
              {/* <PopImage Imgsrc={data.aboutImg} /> */}
              <StackImage Imgsrc={data.aboutImg} />
              {/* <DefaultImage Imgsrc={data.aboutImg} /> */}
              {/* <RotateImage Imgsrc={data.aboutImg} /> */}
              {/* <GroupImage Imgsrc={data.aboutImg} /> */}
            </div>
          </div>
        </div>
      </Container>
    </Section>
  );
}
export default AboutSection;
